import { clsx } from '@appvantageasia/core-utils';
import { NavigateItem } from '../types';
import Tooltip from '@/components/common/Tooltip';

interface MenuItemProps {
    index: number;
    activeIndex: number | null;
    item: NavigateItem;
    onClick: (index: number) => void;
}

const MenuItem = ({ index, activeIndex, item, onClick }: MenuItemProps) => {
    return (
        <div className="mb-3 w-full last:mb-0">
            <Tooltip title={item.name}>
                <button
                    onClick={() => onClick(index)}
                    data-cy={`singleIconMenu-${item.key}`}
                    className={clsx(
                        'relative mx-auto flex h-12 w-12 cursor-pointer flex-col items-center justify-center rounded-md transition-all duration-300',
                        {
                            'bg-primary/10 dark:bg-primary dark:text-primary-foreground text-primary data-[state=delayed-open]:bg-primary/10':
                                activeIndex === index,
                            'text-default-500 dark:text-default-400 data-[state=delayed-open]:bg-primary/10 data-[state=delayed-open]:text-primary':
                                activeIndex !== index,
                        }
                    )}
                >
                    {item.icon && <item.icon className="h-5 w-5" />}
                </button>
            </Tooltip>
        </div>
    );
};

export default MenuItem;
